/**
 * Physical form of a fertilizer salt for UI (Workflow Stage 3).
 *
 * - Powder (solid): show solubility (g/L); density is N/A
 * - Liquid: density applies (g/mL or g/cm³); solid solubility g/L is N/A
 */

export type SaltPhysicalForm = 'liquid' | 'powder';

export function detectSaltPhysicalForm(input: {
  name: string;
  formula?: string | null;
  density?: number | null;
  solubility?: number | null;
  isLiquid?: boolean | null;
}): SaltPhysicalForm {
  if (input.isLiquid === true) return 'liquid';
  if (input.isLiquid === false) return 'powder';

  const name = (input.name || '').toLowerCase();
  const formula = (input.formula || '').toLowerCase();

  // Explicit liquid cues
  if (/\bliquid\b|\bsolution\b|\baqueous\b/.test(name)) return 'liquid';

  // Common liquid acids used in hydroponics (not solid boric acid)
  if (
    /phosphoric acid|nitric acid|sulfuric acid|sulphuric acid|hydrochloric|acetic acid/.test(
      name
    ) ||
    formula === 'h3po4' ||
    formula === 'hno3'
  ) {
    return 'liquid';
  }

  // Percent acids e.g. "Phosphoric Acid (75%)"
  if (/\bacid\s*\(\s*\d+\s*%\s*\)/.test(name)) return 'liquid';

  // Everything else treated as powder/solid fertilizer
  return 'powder';
}

export function physicalFormLabel(form: SaltPhysicalForm): string {
  return form === 'liquid' ? 'Liquid' : 'Powder';
}
